import { Box } from '@zillow/constellation-10';
import Bone from '../Bone';
import { AvatarGroup } from '@zg-rentals/satellite-components';
import { conversationNavWrapperStyles } from '.';

export default function ConversationNavSkeleton(): JSX.Element {
  return (
    <Box css={conversationNavWrapperStyles}>
      <AvatarGroup participants={['']} />
      <Box css={{ width: '40%', marginLeft: 'default' }}>
        <Bone dark={true} type="line" />
      </Box>
    </Box>
  );
}
